import { t } from 'ttag'

import {
  FileIcon,
  FileTextIcon,
  LifeBuoyIcon,
  SettingsIcon,
  GridIcon,
  UsersIcon,
  TargetIcon,
} from 'components/shared/Icon/model'
import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS } from 'constants/templates'
import { DEFAULT_DEPARTMENTS_QUERY_PARAMS } from 'constants/departments'
import { DEFAULT_PANEL_QUERY_PARAMS } from 'constants/panel'
import {
  toModel,
  toPage,
  toProjects,
  toTemplates,
  toDepartments,
  toPanel,
} from 'ducks/router'

export const ACCOUNT_TYPE = 'ACCOUNT_TYPE'
export const DOCUMENTS_TYPE = 'DOCUMENTS_TYPE'
export const HOME_TYPE = 'HOME_TYPE'
export const JOBS_TYPE = 'JOBS_TYPE'
export const TEMPLATES_TYPE = 'TEMPLATES_TYPE'
export const DEPARTMENTS_TYPE = 'DEPARTMENTS_TYPE'
export const TRAINING_TYPE = 'TRAINING_TYPE'
export const PANEL_TYPE = 'PANEL_TYPE'

export const getNavigationLinks = () => [
  { icon: TargetIcon, label: t`jobs`, type: JOBS_TYPE },
  {
    icon: FileTextIcon,
    label: t`templates`,
    type: TEMPLATES_TYPE,
    isActive: (_, location) => location.pathname.includes('/templates/'),
  },
  // { icon: FileIcon, label: t`documents`, type: DOCUMENTS_TYPE },
  // {
  //   icon: SettingsIcon,
  //   label: t`account`,
  //   featureFlag: 'accountAdmin',
  //   type: ACCOUNT_TYPE,
  // },
  {
    icon: LifeBuoyIcon,
    label: t`training`,
    featureFlag: 'trainingPage',
    type: TRAINING_TYPE,
  },
  {
    icon: GridIcon,
    label: t`departments`,
    featureFlag: 'accountAdmin',
    type: DEPARTMENTS_TYPE,
  },
  {
    icon: UsersIcon,
    label: t`access control`,
    featureFlag: 'accountAdmin',
    type: PANEL_TYPE,
  },
]

export const getLinkActions = type => {
  const mapTypeToLinkAction = {
    [JOBS_TYPE]: toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS),
    [TEMPLATES_TYPE]: toTemplates(
      'interviews',
      null,
      DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS,
    ),
    [DEPARTMENTS_TYPE]: toDepartments(null, DEFAULT_DEPARTMENTS_QUERY_PARAMS),
    [DOCUMENTS_TYPE]: toModel('documents', null, null, {
      limit: 25,
      offset: 0,
      ordering: ['title'],
    }),
    [ACCOUNT_TYPE]: toPage('account'),
    [TRAINING_TYPE]: toPage('training'),
    [PANEL_TYPE]: toPanel(null, DEFAULT_PANEL_QUERY_PARAMS),
  }

  return mapTypeToLinkAction[type]
}
